import $ from 'jquery';

// TODO: Migrate to react based modal (like postpone one)
export default onSubmit => {
  const $modal = $('#modal-publish-settings');

  $modal
    .modal({
      onVisible: () => {
        $modal.find('.ui.checkbox').checkbox();
      },
      onApprove: element => {
        const push = $modal.find('.ui.checkbox').hasClass('checked');
        const $button = $(element);

        $button.addClass('loading');
        onSubmit(push).then(_ => {
          $button.removeClass('');
          $modal.modal('hide');
        });

        return false;
      },
    })
    .modal('show');
};



// WEBPACK FOOTER //
// ./src/modules/news/publish.js